<template>
 <div> <h2>{{this.$route.params.id}}</h2>
  {{usuarios}}</div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      empleado:  [],
      usuarios: [],
    }
  },
  created() {
    this.getEmployeeDetails();
    this.listar();
  },
  methods: {
    getEmployeeDetails() {
      let me = this; 
      this.isLoading = true;
      axios
        .get("employee/" + this.$store.state.usuario._id)
        .then(res => {  
            me.empleado = res;   
        })
        .then( res => {
          this.isLoading = false;
        })
        .catch(error => {});
    },
    listar() {
      let me = this; 
      this.isLoading = true;
      axios
        .get("users/" + this.$store.state.usuario._id+'/status=true')
        .then(res => {   
            me.usuarios = res.data;   
        })
        .then( res => {
          this.isLoading = false;
        })
        .catch(error => {});
    },
  }
}
</script> 